import Icon from '../components/Icon.vue'

Icon.register({
  'calendar-minus': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 160h-424c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-260c0-6.6 5.4-12 12-12zM316 384c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-184c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/calendar-minus.js
// module id = 1134
// module chunks = 0